<div [class.container]="isVerticalLayout$ | async" class="toolbar w-full ltr:pr-4 rtl:pl-4 flex items-center">
  <button (click)="openSidenav()" [class.hidden]="!mobileQuery" mat-icon-button type="button">
    <mat-icon svgIcon="mat:menu"></mat-icon>
  </button>

  <a *ngIf="isVerticalLayout$ | async" [routerLink]="['/']" class="ltr:mr-4 rtl:ml-4 block flex items-center">
    <img alt="Logo" class="w-8 select-none" src=""/>
    <!--    <h1 [class.hidden]="!mobileQuery" class="title ltr:pl-4 rtl:pr-4 m-0 select-none">Al-Maqraa</h1>-->
  </a>

  <mat-menu #settings="matMenu" [overlapTrigger]="false" xPosition="after" yPosition="below">


  </mat-menu>

  <div class="recent d-flex">
    <a *ngFor="let feature of features"
       class="text-dark mt-2 py-2 cursor-pointer text-center lg:mx-3 quick-access-item position-relative hover:bg-primary/5 hover:text-primary trans-ease-out rounded block no-underline">
      <mat-icon svgIcon="mat:delete" (click)="removeQuickAccess($event, feature)"
                class="icon-sm position-absolute remove-icon" color="primary"></mat-icon>
      <div class="m-0 p-0" [routerLink]="feature?.link">
        <mat-icon [svgIcon]="feature.icon" class="icon-l mx-4" color="primary"></mat-icon>
        <div class="body-2 hidden sm:block">{{feature.title | translate }}</div>
      </div>
    </a>
  </div>
  <div *ngIf="(isVerticalLayout$ | async) && isNavbarInToolbar$ | async" [class.hidden]="mobileQuery"
       class="px-gutter flex-none flex items-center">
    <app-navigation-item *ngFor="let item of navigationItems" [item]="item"></app-navigation-item>
  </div>

  <span class="flex-1"></span>
  <div class="-mx-1 flex items-center">
    <div class="px-1">
      <!--      <app-toolbar-notifications></app-toolbar-notifications>-->
    </div>

    <!--    <div class="px-1">-->
    <!--      <button (click)="openQuickpanel()" mat-icon-button type="button" [matMenuTriggerFor]="settings">-->
    <!--        <mat-icon color="primary" svgIcon="mat:settings_input_component"></mat-icon>-->
    <!--      </button>-->
    <!--    </div>-->

    <!--    <div class="px-1">-->
    <!--      <button [matMenuTriggerFor]="languageMenu" mat-icon-button type="button">-->
    <!--        &lt;!&ndash;        <mat-icon svgIcon="{{selectedLanguage?.prefix}}"></mat-icon>&ndash;&gt;-->
    <!--        <span>{{selectedLanguage?.prefix}}</span>-->
    <!--      </button>-->
    <!--    </div>-->

    <div *ngIf="userVisible$ | async" class="px-1">
      <app-toolbar-user></app-toolbar-user>
    </div>

    <mat-menu #languageMenu="matMenu" overlapTrigger="false" xPosition="before" yPosition="below">
      <ng-container *ngFor="let language of languageList">
        <button mat-menu-item (click)="changeSiteLanguage(language.code)" class="d-flex justify-content-center">
          <!--          <mat-icon svgIcon="{{language.flag}}"></mat-icon>-->
          <span> {{ language.label | translate }}
          </span>
        </button>
      </ng-container>
    </mat-menu>
  </div>
</div>

<app-navigation *ngIf="(isVerticalLayout$ | async) && isNavbarBelowToolbar$ | async"
                [class.hidden]="mobileQuery"></app-navigation>
